<div
    class="fixed bottom-8 right-8 z-[1050] h-fit gap-2 rounded-lg border border-neutral-03.5 bg-neutral-01 px-4 py-2 shadow-md flex-row-center mb:left-4 mb:right-4 mb:top-4 mb:w-[calc(100svw-2rem)]"
    *ngIf="progress.at(0); let message"
    @showProgress
>
    <svg-icon src="assets/icons/loading.svg" svgClass="size-4 animate-spin" />
    <span class="font-lato-semibold text-sm font-semibold">{{ getMessage(message) }}</span>
</div>
